import { getAcronym } from '@teem/helpers/functions';
import * as Api from '@teem/core/constants/api';
import * as moment from 'moment';
import { messages as i18n } from '@teem/constants/messages';
import { ACTIONS as INVOICE_ACTIONS } from '@teem/constants/invoice';

export default class DraftsTableSchema {
	keyColumn: string = 'uuid';
	userInfo: any = (window as any).userInfo;
	containerContext: any;
	serverUrl: string = `${Api.invoice.all}?is_draft=1`;
	headers: Array<object> = [
		{ "label": "#", "thClass": "th-number" },
		{ "label": $localize`:@@ts.date:Date`, "thClass": "th-date" },
		{ "label": $localize`:@@ts.client:Client`, "thClass": "th-client" },
		// { "label": $localize`:@@ts.project_name:Project Name`, "thClass": "th-project" },
		{ "label": $localize`:@@ts.amount:Amount`, "thClass": "th-amount" },
		{ "label": $localize`:@@ts.status:Status`, "thClass": "th-status text-center" },
		{ "label": "", "thClass": "th-editdelete" },
	];
	cols: Array<object> = [
		{ "key": "invoice_number", "tdClass": "td-number" },
		{
			"key": "invoice_date", "tdClass": "td-date",
			"render": (value) => {
				let d = moment(value);
				if (d.isValid()) {
					return (
						`<div class="date">
							<span class="day">${d.format('DD')}</span>
							<span class="month">${d.format('MMM')}</span>
							<span class="year">${d.format('YYYY')}</span>
						</div>`
					);
				}

				return '';
			}
		},
		{
			"key": "client_name", "tdClass": "td-client-name",
			//"render": (value) => `<span class="name-alpha">${value ? getAcronym(value) : ""}</span>${value ? value : ''}`
		},
		// { "key": "title", "tdClass": "td-project-name" },
		{ 
			"key": "total_amount", 
			"tdClass": "td-amount", 
			"render": (value, row) => { 
				let currency = row.currency ? row.currency : this.userInfo.currency_symbol;
				return `<div class="amount">
							<span class="price">${value ? value : 0}</span>
							<span class="sar">${currency}</span>
						</div>`
				// return this.containerContext.currencyPipe.transform(value ? value : 0) 
			} 
		},
		{
			"key": "email_status", "tdClass": "td-status",
			"render": (value, row) => {
	  
			  let status = i18n[value] ? i18n[value] : i18n.unsent;
			  let colorClass = 'highlight';
	  
			  if (value == 'viewed') {
				colorClass = 'success';
			  } else if (value == 'sent') {
				colorClass = 'warning';
			  }
	  
			  return `<span class="dot-status revealed ${colorClass}" ><i>${status}</i></span>`;
			}
		},
		{
			"key": "uuid", "tdClass": "td-editdelete", 
			"render": (value) => `<a href="javascript:void(0);" class="delete">
							<svg class="delete-invoice-btn" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
								<g fill="none" fill-rule="evenodd">
									<g fill="#FB4575">
										<path d="M8.25 10.083c.504 0 .917.413.917.917v3.667c0 .504-.413.916-.917.916s-.917-.412-.917-.916V11c0-.504.413-.917.917-.917zm5.5 0c.504 0 .917.413.917.917v3.667c0 .504-.413.916-.917.916s-.917-.412-.917-.916V11c0-.504.413-.917.917-.917zm2.75 7.334c0 .505-.41.916-.917.916H6.417c-.506 0-.917-.411-.917-.916V7.333h11v10.084zM9.167 3.967c0-.142.196-.3.458-.3h2.75c.262 0 .458.158.458.3V5.5H9.167V3.967zM19.25 5.5h-4.583V3.967c0-1.177-1.028-2.134-2.292-2.134h-2.75c-1.264 0-2.292.957-2.292 2.134V5.5H2.75c-.504 0-.917.412-.917.917 0 .504.413.916.917.916h.917v10.084c0 1.516 1.234 2.75 2.75 2.75h9.166c1.516 0 2.75-1.234 2.75-2.75V7.333h.917c.504 0 .917-.412.917-.916 0-.505-.413-.917-.917-.917z" transform="translate(-244 -54) translate(244 53) translate(0 1)"/>
									</g>
								</g>
							</svg>
						</a>
						<a href="javascript:void(0);" class="edit">
							<svg class="edit-invoice-btn" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
								<g fill="none" fill-rule="evenodd">
									<g fill="#1C6AB6">
										<path d="M12.683 8.444l-2.134-2.137 1.542-1.545 2.133 2.136-1.541 1.546zM7.189 13.95l-2.357.214.209-2.343 4.447-4.453 2.134 2.137-4.433 4.445zm8.174-8.156h-.001l-2.168-2.171c-.587-.586-1.595-.614-2.15-.055L3.92 10.701c-.258.258-.418.6-.451.962l-.3 3.306c-.02.234.062.466.229.632.15.15.351.232.56.232.024 0 .048 0 .071-.003l3.302-.3c.363-.034.704-.193.961-.45l7.123-7.133c.577-.579.552-1.544-.053-2.152z" transform="translate(-875 -616) translate(96 587) translate(779 29)"/>
									</g>
								</g>
							</svg>
						</a>`,
			"dataClick": (e, value?: any, row?: any) => {
				if (e.target.classList.contains('edit') || e.target.classList.contains('edit-invoice-btn')) {
					this.containerContext.invoiceActions(INVOICE_ACTIONS.EDIT, row);
					// this.containerContext.invoiceActions(INVOICE_ACTIONS.VIEW, row);
				}
				if (e.target.classList.contains('delete') || e.target.classList.contains('delete-invoice-btn')) {
					this.containerContext.invoiceActions(INVOICE_ACTIONS.DELETE, row);
				}
			}
		},
	];

	constructor(container: any) {
		this.containerContext = container;
	}
}
